import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import styles from "./Auth.module.css";
import { toast } from "react-toastify";
/* import { loginAPI } from "../apis/AuthApi"; */
import { AuthApis } from "../../../api/auth/auth";
import { useAuth } from "../Context/AuthContext";
import { CgLayoutGrid } from "react-icons/cg";

function Auth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState("");
  const [activeField, setActiveField] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  const togglePassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!email || !password) {
      setError("Email and password cannot be empty!");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address!");
      return;
    }

    // Real backend call
    try {
      setLoading(true);
      setError("");
      const data = { email, password };
      const response = await AuthApis.AdminLogin(data);

      if (response.status === 200) {
        const userData = response.data.user;
        const token = response.data.access;

        if (token) {
          login(userData, token);
        } else {
          console.warn("No token found in response:", response.data);
        }

        navigate("/admin/create");
        toast.success("Login successful");
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Login failed. Please check your credentials.");
      } 
      else {
        toast.error("Something went wrong. Please try again.");
        console.log("Login error:", err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card overflow-hidden">
              <div className="bg-primary bg-soft">
                <div className="row">
                  <div className="col-7">
                    <div className="text-primary p-4">
                      <h5 className="text-primary">Login Page!</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <div className="p-2">
                  <form className="form-horizontal" onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <div className="mb-3 text-start">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="text"
                        id="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onFocus={() => setActiveField("email")}
                        onBlur={() => setActiveField("")}
                        className={`${styles.inputField} ${
                          activeField === "email" ? styles.active : ""
                        }`}
                      />
                    </div>

                    {/* Password Field */}
                    <div className="mb-3 text-start">
                      <label className="form-label">Password</label>
                      <div className={styles.passwordWrapper}>
                        <input
                          type={passwordVisible ? "text" : "password"}
                          placeholder="Enter password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onFocus={() => setActiveField("password")}
                          onBlur={() => setActiveField("")}
                          className={`${styles.inputField} ${
                            activeField === "password" ? styles.active : ""
                          }`}
                        />
                        <button
                          type="button"
                          className={styles.passwordToggleBtn}
                          onClick={togglePassword}
                        >
                          <i
                            className={
                              passwordVisible ? "bi bi-eye-slash" : "bi bi-eye"
                            }
                          ></i>
                        </button>
                      </div>
                    </div>

                    {/* Error Message */}
                    {error && <div className="text-danger mb-2">{error}</div>}

                    {/* Login Button */}
                    <div className="mt-3 d-grid">
                      <button
                        type="submit"
                        className={styles.loginBtn}
                        disabled={loading}
                      >
                        {loading ? "Logging in..." : "Log In"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Auth;
